<script>
import { register } from "swiper/element/bundle";
import "swiper/css";

register();

export default {
  name: "ExpertsList",
  components: {
    ExpertContent: {
      props: {
        expert: {
          type: Object,
          required: true,
        },
      },
      template: `
        <div class="card">
            <div class="card-img-top aspect-ratio-box ratio-16-9">
                <picture class="aspect-image-container">
                    <source :srcset="expert.webp" type="image/webp">
                    <source :srcset="expert.jpeg" type="image/jpeg">
                    <img :alt="expert.name" :src="expert.img">
                </picture>
            </div>
            <div class="card-body x-small">
                <strong>{{ expert.name }}</strong>
                <br>
                <p>{{ expert.role }}</p>
            </div>
        </div>
      `,
    },
  },
  props: {
    experts: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      useSwiper: false,
    };
  },
  methods: {
    getCssCustomProperty(property) {
      return getComputedStyle(document.documentElement).getPropertyValue(property).trim();
    },
    updateSwiper() {
      const breakpointSm = parseInt(this.getCssCustomProperty("--breakpoint-sm"), 10);
      this.useSwiper = window.innerWidth <= breakpointSm;
    },
  },
  mounted() {
    this.updateSwiper();
    window.addEventListener("resize", this.updateSwiper);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateSwiper);
  },
};
</script>

<template>
  <div class="experts-list">
    <swiper-container
        v-if="useSwiper"
        :slides-per-view="1.25"
        :space-between="15"
        :slides-offset-before="15"
        :loop="true"
        class="experts-list-swiper"
    >
      <swiper-slide
          v-for="(expert, index) in experts"
          :key="index"
      >
        <ExpertContent :expert="expert" />
      </swiper-slide>
    </swiper-container>
    <div
        v-else
        class="card-deck card-deck-cols-xl-6 card-deck-cols-lg-5 card-deck-cols-md-4 card-deck-cols-sm-3"
    >
      <ExpertContent
          v-for="(expert, index) in experts"
          :key="index"
          :expert="expert"
      />
    </div>
  </div>
</template>